import Api from '../api';

const resource = '/language';

export default {
  get() {
    return Api.get(`${resource}`);
  },
};

export interface LocalizationResponseItem {
  code: string;
  default: boolean;
  fakeCode: string;
  flag: string;
  label: string;
  locale: string;
  popular: boolean;
}
